export const DEFAULT_BUCKET_NAME = 'base';
export const CUSTOM_BUCKET_NAME = 'Custom fields';
export const FILTER_MODE_BUCKET_NAME = 'Filter modes';

const TODAY = {id: 'd', value: 'Today'} as const;
const YESTERDAY = {id: 'd-1', value: 'Yesterday'} as const;
const LAST_7_DAYS = {id: '-d7', value: 'Last 7 days'} as const;
const LAST_30_DAYS = {id: '-d30', value: 'Last 30 days'} as const;
const LAST_90_DAYS = {id: '-d90', value: 'Last 90 days'} as const;

// We use this as the default in some places when there's an invalid filter
export const LAST_365_DAYS = {id: '-d365', value: 'Last 365 days'} as const;

const NEXT_7_DAYS = {id: '+d7', value: 'Next 7 days'} as const;
const NEXT_30_DAYS = {id: '+d30', value: 'Next 30 days'} as const;
const NEXT_90_DAYS = {id: '+d90', value: 'Next 90 days'} as const;
const NEXT_365_DAYS = {id: '+d365', value: 'Next 365 days'} as const;

const LAST_WEEK = {id: 'w-1', value: 'Last week'} as const;
const LAST_MONTH = {id: 'm-1', value: 'Last month'} as const;
const LAST_QUARTER = {id: 'q-1', value: 'Last quarter'} as const;
const LAST_YEAR = {id: 'y-1', value: 'Last year'} as const;
const LAST_FISCAL_YEAR = {id: 'fy-1', value: 'Last fiscal year'} as const;

const NEXT_WEEK = {id: 'w+1', value: 'Next week'} as const;
const NEXT_MONTH = {id: 'm+1', value: 'Next month'} as const;
const NEXT_QUARTER = {id: 'q+1', value: 'Next quarter'} as const;
const NEXT_YEAR = {id: 'y+1', value: 'Next year'} as const;
const NEXT_FISCAL_YEAR = {id: 'fy+1', value: 'Next fiscal year'} as const;

const THIS_WEEK = {id: 'w', value: 'This week'} as const;
const THIS_MONTH = {id: 'm', value: 'This month'} as const;
const THIS_QUARTER = {id: 'q', value: 'This quarter'} as const;
const THIS_YEAR = {id: 'y', value: 'This year'} as const;
const THIS_FISCAL_YEAR = {id: 'fy', value: 'This fiscal year'} as const;

const FIRST_HOUR = {id: '+h1', value: 'First hour'} as const;
const FIRST_4_HOURS = {id: '+h4', value: 'First 4 hours'} as const;
const FIRST_12_HOURS = {id: '+h12', value: 'First 12 hours'} as const;
const FIRST_24_HOURS = {id: '+d1', value: 'First 24 hours'} as const;
const FIRST_48_HOURS = {id: '+d2', value: 'First 48 hours'} as const;
const FIRST_7_DAYS = {id: '+d7', value: 'First 7 days'} as const;

const CUSTOM = {id: 'custom', value: 'Custom'} as const;

export const DATE_RANGES_FUTURE = [
    NEXT_7_DAYS,
    NEXT_30_DAYS,
    NEXT_90_DAYS,
    NEXT_365_DAYS,
    THIS_WEEK,
    THIS_MONTH,
    THIS_QUARTER,
    THIS_YEAR,
    THIS_FISCAL_YEAR,
    NEXT_WEEK,
    NEXT_MONTH,
    NEXT_QUARTER,
    NEXT_YEAR,
    NEXT_FISCAL_YEAR,
    CUSTOM,
] as const;

export const DATE_RANGES_PAST = [
    TODAY,
    YESTERDAY,
    LAST_7_DAYS,
    LAST_30_DAYS,
    LAST_90_DAYS,
    LAST_365_DAYS,
    THIS_WEEK,
    THIS_MONTH,
    THIS_QUARTER,
    THIS_YEAR,
    THIS_FISCAL_YEAR,
    LAST_WEEK,
    LAST_MONTH,
    LAST_QUARTER,
    LAST_YEAR,
    LAST_FISCAL_YEAR,
    CUSTOM,
] as const;

export const DATE_RANGES_MINUTES = [
    FIRST_HOUR,
    FIRST_4_HOURS,
    FIRST_12_HOURS,
    FIRST_24_HOURS,
    FIRST_48_HOURS,
    FIRST_7_DAYS,
] as const;

export const DATE_RANGES_FORMS = [
    TODAY,
    LAST_7_DAYS,
    LAST_30_DAYS,
    LAST_90_DAYS,
    LAST_365_DAYS,
    THIS_WEEK,
    THIS_MONTH,
    THIS_QUARTER,
    THIS_YEAR,
    THIS_FISCAL_YEAR,
    LAST_WEEK,
    LAST_MONTH,
    LAST_QUARTER,
] as const;

export const DATE_RANGES_ANALYTICS = [
    THIS_MONTH,
    LAST_MONTH,
    THIS_QUARTER,
    LAST_7_DAYS,
    LAST_30_DAYS,
    LAST_90_DAYS,
] as const;

export const DATE_RANGES_DASHBOARD = DATE_RANGES_PAST;

export const DATE_RANGES_ENGAGEMENT_DASHBOARD = [LAST_7_DAYS, LAST_30_DAYS, LAST_90_DAYS] as const;

export const DATE_RANGES_ATTRIBUTION = [
    LAST_7_DAYS,
    LAST_30_DAYS,
    LAST_90_DAYS,
    LAST_365_DAYS,
    THIS_WEEK,
    THIS_MONTH,
    THIS_QUARTER,
    THIS_YEAR,
    THIS_FISCAL_YEAR,
    LAST_WEEK,
    LAST_MONTH,
    LAST_QUARTER,
    LAST_YEAR,
    LAST_FISCAL_YEAR,
] as const;
